'use client';
import React, { useState, useCallback, useEffect } from 'react';
import AppLayout from '@/components/AppLayout';
import PostFeed from '@/app/components/PostFeed';
import CreatePostForm from '@/app/components/CreatePostForm';
import BoostPopup from '@/app/components/BoostPopup';

const SOCIAL_PROOF_LINES = [
  'People are already proving each other wrong.',
  'Arguments are happening right now.',
  'Others are jumping in.',
];

function SocialProof() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIndex((i) => (i + 1) % SOCIAL_PROOF_LINES.length);
        setVisible(true);
      }, 300);
    }, 2800);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex items-center justify-center py-2">
      <p
        className="text-xs font-semibold text-primary transition-opacity duration-300"
        style={{ opacity: visible ? 1 : 0 }}
      >
        🔥 {SOCIAL_PROOF_LINES[index]}
      </p>
    </div>
  );
}

export default function FeedPage() {
  const [feedKey, setFeedKey] = useState(0);
  const [showBoostPopup, setShowBoostPopup] = useState(false);
  const [newPostId, setNewPostId] = useState<string | null>(null);
  const [newPostSlug, setNewPostSlug] = useState<string | null>(null);

  const handlePostCreated = useCallback((postId?: string, postSlug?: string) => {
    setFeedKey((k) => k + 1);
    if (postId) setNewPostId(postId);
    if (postSlug) setNewPostSlug(postSlug);
    setShowBoostPopup(true);
  }, []);

  return (
    <AppLayout>
      <div className="py-6 max-w-2xl mx-auto">
        <CreatePostForm onPostCreated={handlePostCreated} />
        <SocialProof />
        <div className="mt-4">
          <PostFeed key={feedKey} />
        </div>
      </div>

      {showBoostPopup && (
        <BoostPopup
          postId={newPostId}
          postSlug={newPostSlug}
          onClose={() => setShowBoostPopup(false)}
        />
      )}
    </AppLayout>
  );
}